module.exports = {
  output: require('./output')
}



//////////////////
// WEBPACK FOOTER
// ./~/htmlcoinjs-lib/~/bitcoinjs-lib/src/templates/witnesscommitment/index.js
// module id = ujvt
// module chunks = 0